export const transponderDocumentationLinks = {
  DETERMINING_YOUR_INFRASTRUCTURE: 'https://docs.ketch.com/ketch/docs/deploying-ketch-transponders',
  DEPLOYING_THE_TRANSPONDER: 'https://docs.ketch.com/ketch/docs/deploying-ketch-transponders',
  CONNECT_THE_TRANSPONDER_TO_KETCH: 'https://docs.ketch.com/ketch/docs/connection-the-ketch-transponder-to-ketch',
  TRANSPONDER_OVERVIEW: 'https://docs.ketch.com/ketch/docs/deploying-ketch-transponders',
}
